import React from "react";

export default () => <div className="InfoIcon icon">i</div>